import { ArrowLeft } from '@eduzz/houston-icons';
import { API_V4_BASE_URL, BRANCH_NAME, BUILD_DATE, BUILD_NUMBER, ENV, IS_PROD } from 'settings';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useRef, useState } from 'react';
import { get } from 'services/api';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      position: 'fixed',
      top: '-5px',
      left: 'calc(50% - 100px)',
      zIndex: 9999,
    },
    content: {
      background: theme.palette.secondary.dark || '#00642e',
      borderRadius: '5px',
      color: 'white',
      textShadow: '0 0 1px #00000094',
      fontWeight: 'bold',
      fontSize: '12px',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      boxShadow: '0px 1px 3px #00000059',
      padding: '8px 30px 3px',
    },
    arrowLeft: {
      left: -20,
      top: 5,
      position: 'absolute',
      cursor: 'pointer',
    },
    hide: {
      display: 'none',
    },
  };
});

const EnvironmentComponent = () => {
  const classes = useStyles();
  const contentRef = useRef<any>();
  const [activeClasses, setActiveClasses] = useState(classes.container);
  const [version, setVersion] = useState<any>();
  useEffect(() => {
    contentRef?.current?.addEventListener(
      'click',
      (event: MouseEvent) => {
        if (event.detail === 4) {
          remove();
        }
      },
      false
    );
  }, [contentRef]);

  useEffect(() => {
    get({ url: `/`, baseURL: API_V4_BASE_URL }).then((item) => setVersion(item.data));
  }, []);

  const remove = () => setActiveClasses(`${classes.hide}`);

  return (
    <div className={`${activeClasses}`}>
      <div onClick={remove} className={classes.arrowLeft}>
        <ArrowLeft />
      </div>
      <div ref={contentRef} className={classes.content}>
        FRONT: {ENV} {BRANCH_NAME} (v3.{BUILD_NUMBER} - {BUILD_DATE})
        {version && (
          <>
            {' '}
            - API: {version.tag} {version.buildDate} #{version.build}
          </>
        )}
      </div>
    </div>
  );
};

const Environment = () => {
  if (IS_PROD) return null;

  return <EnvironmentComponent />;
};

export default Environment;
